var map = {
	"./history/common/loading_iSpt.png": "11gh",
	"./theme1/common/loading_iSpt.png": "4fTm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6T6k";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/common\/loading_iSpt\.png$
// module id = 6T6k
// module chunks = 319